import React from "react";
import EATextField from "../shared/TextField/EATextField";
import { LoginData } from "../../models/LoginData";
import { useTranslation } from "react-i18next";

interface IProps {
  form: LoginData;
  setForm: (value: LoginData) => void;
}

const LoginInputs: React.FC<IProps> = ({ form, setForm }) => {
  const { t } = useTranslation();

  return (
    <div className="login-inputs">
      <EATextField
        label={"E-mail"}
        type="email"
        name="email"
        placeholder={"E-mail"}
        value={form.login}
        onChange={(e) => setForm({ ...form, login: e.target.value })}
        fullWidth
      />
      <EATextField
        label={t("haslo")}
        type="password"
        name="password"
        placeholder={t("haslo")}
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
        fullWidth
      />
    </div>
  );
};

export default LoginInputs;
